// The seven intelligence themes that organise Selling Sunsets research.
export const THEMES = [
  {
    slug: "land-and-regulation",
    index: "01",
    title: "Land & Regulation",
    summary:
      "How land is classified, who governs it, and the rules that decide what can be bought, built and transferred in the hills.",
    detail:
      "Agricultural versus non-agricultural land, ceiling provisions, conversion, and the state-specific restrictions that shape who may purchase land in Uttarakhand.",
  },
  {
    slug: "locations",
    index: "02",
    title: "Locations",
    summary:
      "Place-by-place intelligence — terrain, access, micro-climate and the practical character of each market.",
    detail:
      "From the Doon Valley floor to Kumaon ridgelines, each location carries a different risk and opportunity profile.",
  },
  {
    slug: "due-diligence",
    index: "03",
    title: "Due Diligence",
    summary:
      "The questions, documents and checks a buyer should complete before committing to any property.",
    detail:
      "Title, encumbrance, mutation, revenue records, access rights and physical verification — structured into a repeatable process.",
  },
  {
    slug: "planning-and-development",
    index: "04",
    title: "Planning & Development",
    summary:
      "Master plans, development authorities and the planning context that governs what a site can become.",
    detail:
      "Which authority has jurisdiction, what the land-use designation permits, and how planning intent affects long-term value.",
  },
  {
    slug: "second-homes",
    index: "05",
    title: "Second Homes",
    summary:
      "What changes when a hill property is a retreat rather than a residence — access, maintenance, caretaking and seasonality.",
    detail:
      "The operational realities of owning from a distance, and the design and location choices that make a second home sustainable.",
  },
  {
    slug: "investment-research",
    index: "06",
    title: "Investment Research",
    summary:
      "A measured view of value drivers — without invented appreciation figures or speculative projections.",
    detail:
      "How connectivity, scarcity, regulation and demand interact, and the evidence a serious buyer should look for.",
  },
  {
    slug: "construction-and-ownership",
    index: "07",
    title: "Construction & Ownership",
    summary:
      "Building and holding property in a hill environment — approvals, slope, services and ongoing responsibility.",
    detail:
      "Structural considerations on sloping ground, utilities, approvals and the real cost of ownership over time.",
  },
];

export default THEMES;
